module.exports = __webpack_public_path__ + "img/keF.3b882b72.png";